import { render, staticRenderFns } from "./Inputworkspace.vue?vue&type=template&id=d2faab40&scoped=true"
import script from "./Inputworkspace.vue?vue&type=script&lang=js"
export * from "./Inputworkspace.vue?vue&type=script&lang=js"
import style0 from "./Inputworkspace.vue?vue&type=style&index=0&id=d2faab40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2faab40",
  null
  
)

export default component.exports